
import Breadcrumb from '@/components/Breadcrumb'
export default {
    components: {
        Breadcrumb
    },
    data() {
        return {
            bannerInfo: null
        }
    },
    mounted() {
        this.getBannerInfo()
    },
    methods: {
        getBannerInfo() {
            let info = {
                action: {
                    id: this.$route.query.id
                }
            }
            this.$api.bannerDetail(info).then((res) => {
                if (res.success) {
                    this.bannerInfo = res.data
                    console.log(res.data, 'getBannerInfo')
                }
            })
        }
    }
}
